import { PopoverOrigin } from '@mui/material'
import { FC } from 'react'
import { MeetingDTO, ReplyScheduleDTO } from '../../../../api/gen/base'
import { MeetsInfoPopover } from './MeetsInfoPopover'
import { RegularRequestInfoPopover } from './RegularRequestInfoPopover'

type Props = {
    anchorEl: HTMLElement | null
    onClose?: VoidFunction
    anchorOrigin?: PopoverOrigin
    transformOrigin?: PopoverOrigin
    data?: ReplyScheduleDTO | MeetingDTO
}

export const EventInfoPopover: FC<Props> = ({
    anchorEl,
    onClose,
    anchorOrigin,
    transformOrigin,
    data,
}) => {
    const isRegularRequest = data && 'reply' in data

    if (isRegularRequest) {
        return (
            <RegularRequestInfoPopover
                anchorEl={anchorEl}
                onClose={onClose}
                anchorOrigin={anchorOrigin}
                transformOrigin={transformOrigin}
                data={data}
            />
        )
    }

    return (
        <MeetsInfoPopover
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={anchorOrigin}
            transformOrigin={transformOrigin}
            data={data}
        />
    )
}
